<template>
  <div style="height: 100%">
    <p class="topic">我的笔记</p>
    <div class="mglr-24 mgtb-24">
      <custom-table
        :oriConfig="tableConfig"
        :columns="columns"
        :tableLoading="tableLoading"
        @reset="handleReset()"
        @sorter="(...param) => handleSorterUpdate(...param, columns)"
        ref="custom_table"
      >
        <template slot="tableHeaderRender">
          <a-button type="primary" @click="createNotes()">新建笔记</a-button>
        </template>
        <template slot="tagSearch">
          <custom-table-search
            ref="tag_filter"
            :data="tags"
            :attr="'tag'"
            @search="(val) => handleTagSearch(val, true)"
            @filter="(val) => handleFilter(val)"
          ></custom-table-search>
        </template>
        <span slot="tag" slot-scope="{ record }">
          <a-tag v-for="(item, index) in record.tag" :key="index" class="tag" :title="item">
            <span>{{ item }}</span>
          </a-tag>
        </span>
        <span
          style="text-overflow: ellipsis; cursor: help"
          slot="auditStatus"
          slot-scope="{ record }"
          :title="record.auditComment"
          >{{ record.visibility == 'public' ? AUDIT_STATUS_MAP[record.auditStatus] : '-' }}</span
        >
        <span slot="action" slot-scope="{ record }">
          <a @click="handleSubmit(record)" v-if="submit(record)">重新提交审核</a>
          <a-divider type="vertical" v-if="submit(record)"></a-divider>
          <a @click="handleEditInfo(record)">编辑</a>
          <a-divider type="vertical"></a-divider>
          <a @click="handleEdit(record.uid)">编辑内容</a>
          <a-divider type="vertical"></a-divider>
          <a @click="handleDelete(record.uid)">删除</a>
        </span>
        <span style="text-overflow: ellipsis" slot="updateTime" slot-scope="{ record }">{{
          record.updateTime ? timestamp2Date(record.updateTime) : '-'
        }}</span>
        <span style="text-overflow: ellipsis" slot="visibility" slot-scope="{ record }">{{
          record.visibility == 'public' ? '公开' : '私有'
        }}</span>

        <a slot="name" slot-scope="{ record }" @click="pageToTutorialDetail(record.uid)"
          ><a-icon :type="record.isRecommended ? 'like' : ''" class="mgr-4" />{{ record.title }}</a
        >
      </custom-table>
    </div>
    <create-note
      ref="modal"
      @edit="handleModalEdit"
      :showEdit="!onlyEditInfo"
      :showModal="showModal"
      @close="handleClose"
    ></create-note>
  </div>
</template>
<script>
import { noteListApi, notesTagsApi, deleteNotesApi, submitNoteApi, AUDIT_STATUS_MAP, REAUDIT_STATUS } from '@/api/notes'
import CustomTable from '@/components/Custom/CustomTable.vue'
import CustomTableSearch from '@/components/Custom/CustomTableSearch.vue'
import { timestamp2Date } from '@/utils/util'
import CreateNote from '@/components/Custom/CreateNote.vue'
export default {
  name: 'Notes',
  components: { CustomTable, CustomTableSearch, CreateNote },
  computed: {
    tableConfig() {
      return {
        searchPlaceholder: '请输入笔记关键字进行搜索',
        searchParam: 'search.titleOrSummary',
        loadData: noteListApi,
        pagination: {
          pageNo: 1,
          pageSize: 10,
          total: 0,
        },
        rowKey: 'uid',
        loadParam: { authorId: localStorage.getItem('USER_ID') },
      }
    },
  },
  data() {
    return {
      tags: [],
      tagPagination: {
        pageNo: 0,
        pageSize: 50,
        search: '',
      },
      resetFlag: false,
      tableLoading: false,
      AUDIT_STATUS_MAP,
      columns: [
        {
          title: '名称',
          dataIndex: 'title',
          width: 220,
          sorter: true,
          sortOrder: false,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '标签',
          dataIndex: 'tag',
          width: 150,
          // scopedSlots: { customRender: 'tag', filterDropdown: 'tagSearch'},
          scopedSlots: { customRender: 'tag' },
          filtered: false,
        },
        {
          title: '摘要',
          dataIndex: 'summary',
          width: 200,
          ellipsis: true,
        },
        {
          title: '修改时间',
          dataIndex: 'updateTime',
          width: 120,
          sorter: true,
          sortOrder: false,
          scopedSlots: { customRender: 'updateTime' },
        },
        {
          title: '可见性',
          dataIndex: 'visibility',
          width: 80,
          sorter: true,
          sortOrder: false,
          scopedSlots: { customRender: 'visibility' },
        },
        {
          title: '审核状态',
          dataIndex: 'auditStatus',
          width: 100,
          scopedSlots: { customRender: 'auditStatus' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 200,
          scopedSlots: { customRender: 'action' },
        },
      ],
      showModal: false,
      onlyEditInfo: true,
    }
  },
  methods: {
    updateFilterIcon(filter, flag) {
      this.columns.forEach((item) => {
        if (item.dataIndex === filter) {
          item.filtered = flag
        }
      })
    },
    submit(record) {
      return Object.values(REAUDIT_STATUS).includes(record.auditStatus)
    },
    timestamp2Date,
    handleEditInfo(record) {
      this.$refs.modal.noteInfo = record
      this.onlyEditInfo = true
      this.showModal = true
    },
    createNotes() {
      this.onlyEditInfo = false
      this.showModal = true
    },
    pageToTutorialDetail(id) {
      localStorage.setItem('CURRENT_NOTE_ID', id)
      this.$store.commit('SET_NOTE_ID', id)
      this.$router.push({ name: 'Console' })
    },
    handleTagSearch(val, fuzzy) {
      this.tagPagination.pageNo = 1
      if (val) this.tagPagination.search = { tag: val }
      else delete this.tagPagination.search.tag

      notesTagsApi(this.tagPagination).then((res) => {
        if (fuzzy) this.tags = res.content.data
        else this.tags = res.content.data.filter((item) => item.tag === val)
      })
    },
    handleSorterUpdate(val, dataIndex, columns) {
      columns.map((item) => {
        if (item.dataIndex !== dataIndex && item.sortOrder) {
          item.sortOrder = false
        } else if (item.dataIndex === dataIndex) {
          item.sortOrder = val
        }
        return item
      })
      columns = [...columns]
    },
    handleDelete(uid) {
      const _this = this
      this.$confirm({
        title: '提示',
        content: '确定删除此笔记？',
        okText: '确定',
        cancelText: '取消',
        centered: true,
        maskClosable: true,
        okType: 'danger',
        onOk() {
          deleteNotesApi({ noteId: uid })
            .then((res) => {
              _this.$message.success('删除笔记成功')
              _this.$refs.custom_table.handleRestart()
            })
            .catch((res) => {
              _this.$message.error('删除笔记失败：' + res.response.data.msg + '请稍后重试...')
            })
        },
      })
    },
    handleModalEdit() {
      this.$router.replace({
        name: 'Console',
        params: { createNote: true },
      })
    },
    handleEdit(uid) {
      localStorage.setItem('CURRENT_NOTE_ID', uid)
      this.$store.commit('SET_NOTE_ID', uid)
      this.$router.replace({
        name: 'Console',
        params: { createNote: true },
      })
    },
    handleClose() {
      this.showModal = false
      this.$refs.custom_table.handleRestart()
    },
    handleSubmit(record) {
      submitNoteApi({ noteId: record.uid })
        .then((res) => {
          this.$message.success('提交重新审核笔记成功')
          this.$refs.custom_table.handleRestart()
        })
        .catch((res) => {
          this.$message.error('提交重新审核笔记失败：' + res.response.data.msg)
        })
    },
    handleReset() {
      this.resetFlag = !this.resetFlag
      if (this.$refs.tag_filter) {
        this.$refs.tag_filter.value = []
      }
      this.handleTagSearch(null, true)
      this.updateFilterIcon('tag', false)
    },
    handleFilter(val) {
      this.updateFilterIcon('tag', val.length > 0)
      this.$refs.custom_table.handleFilter(val, 'filter.tag')
    },
  },
}
</script>
<style lang="less" scoped>
.tag {
  max-width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>